module.exports = __webpack_public_path__ + "static/media/48375974_2308815019193676_7513844821048426496_o.6cd99054.jpg";